/* NAKR V477 — horizontal rails: native swipe on touch, mouse-drag on desktop.
   Vertical page scrolling is never prevented. */
(function(){
  var selector = [
    '.nhc-world-editorial__rail',
    '.sev-track',
    '.nlp-grid',
    '.nakr-new-rail__track',
    '.nakr-cross__rail',
    '.sekany-lookbook-products__grid',
    '.product__media-list.slider'
  ].join(',');

  // Prepare all primary card images before the visitor reaches the row.
  // Observe the rail vertically, not each off-screen horizontal image.
  // Product galleries keep their separate color-aware loading policy.
  var imageObserver;
  function prepareImages(rail){
    rail.dataset.nakrImagesPrimed = '1';
    rail.querySelectorAll('img').forEach(function(img){
      if(img.matches('.nakr-hover-secondary, .nlp-secondary')) return;
      img.loading = 'eager';
      if(typeof img.decode === 'function') img.decode().catch(function(){});
    });
  }
  function prepareImagesWhenNear(rail){
    if(rail.matches('.product__media-list.slider')) return;
    if(rail.dataset.nakrImageWatch === '1') {
      if(rail.dataset.nakrImagesPrimed === '1') prepareImages(rail);
      return;
    }
    rail.dataset.nakrImageWatch = '1';
    if('IntersectionObserver' in window){
      if(!imageObserver) imageObserver = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(!entry.isIntersecting) return;
          prepareImages(entry.target);
          imageObserver.unobserve(entry.target);
        });
      }, {rootMargin:'900px 0px 900px 0px', threshold:0});
      imageObserver.observe(rail);
    } else {
      prepareImages(rail);
    }
    ['pointerenter','pointerdown','focusin'].forEach(function(type){
      rail.addEventListener(type, function(){ prepareImages(rail); }, {passive:true});
    });
  }

  function enhanceRail(rail){
    if(!rail) return;
    prepareImagesWhenNear(rail);
    if(rail.dataset.nakrDragReady === '1') return;
    rail.dataset.nakrDragReady = '1';
    rail.style.webkitOverflowScrolling = 'touch';
    rail.style.touchAction = 'pan-x pan-y';

    // Native image/link dragging cancels pointer events before the rail can scroll.
    // Keep normal clicks and touch scrolling; suppress only the browser's drag ghost.
    rail.addEventListener('dragstart', function(e){
      if(e.target.closest('img, a')) e.preventDefault();
    });

    var down = false, startX = 0, startY = 0, startScroll = 0, dragged = false;

    rail.addEventListener('pointerdown', function(e){
      if(e.pointerType !== 'mouse' || e.button !== 0) return;
      if(e.target.closest('button, input, select, textarea, summary')) return;
      down = true; dragged = false;
      startX = e.clientX; startY = e.clientY; startScroll = rail.scrollLeft;
      rail.classList.add('nakr-is-dragging');
    });
    window.addEventListener('pointermove', function(e){
      if(!down) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      if(Math.abs(dx) < 4) return;
      if(Math.abs(dy) > Math.abs(dx) * 1.2) return;
      dragged = true;
      rail.scrollLeft = startScroll - dx;
      e.preventDefault();
    }, {passive:false});
    function end(){
      if(!down) return;
      down = false;
      rail.classList.remove('nakr-is-dragging');
      setTimeout(function(){ dragged = false; }, 0);
    }
    window.addEventListener('pointerup', end);
    window.addEventListener('pointercancel', end);
    rail.addEventListener('click', function(e){
      if(dragged){ e.preventDefault(); e.stopPropagation(); }
    }, true);
  }

  function init(){ document.querySelectorAll(selector).forEach(enhanceRail); }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();
